export default __webpack_public_path__ + "static/yoga-on-marathon-trip-a97c6d21b5b60f49d05875a1a4283603.jpg";